import {setGlobalOptions} from '../loader-utils/merge-options';

// Set global loader options
export function setLoaderOptions(options) {
  setGlobalOptions(options);
}
